import { locale } from '@uikit/ui-kit';

const DEFAULT_UI_LANG = 'en';

function loadLocale(lang) {
  switch (lang.toLowerCase().replace('_', '-')) {
    case 'af':
      return async () => import(/* webpackChunkName: "ui-lc/af-ZA" */ '@uikit/ui-kit/lib/locale/lang/af-ZA.js');
    case 'af-za': // Afrikaans (af-ZA)
      return async () => import(/* webpackChunkName: "ui-lc/af-ZA" */ '@uikit/ui-kit/lib/locale/lang/af-ZA.js');
    case 'ar': // Arabic (ar)
      return async () => import(/* webpackChunkName: "ui-lc/ar" */ '@uikit/ui-kit/lib/locale/lang/ar.js');
    case 'bg': // Bulgarian (bg)
      return async () => import(/* webpackChunkName: "ui-lc/bg" */ '@uikit/ui-kit/lib/locale/lang/bg.js');
    case 'ca': // Catalunya (ca)
      return async () => import(/* webpackChunkName: "ui-lc/ca" */ '@uikit/ui-kit/lib/locale/lang/ca.js');
    // case 'cs':
    //   return async () => import(/* webpackChunkName: "ui-lc/cs-CZ" */ '@uikit/ui-kit/lib/locale/lang/cs-CZ.js');
    // case 'cs-cz': // Czech (cs-CZ)
    //   return async () => import(/* webpackChunkName: "ui-lc/cs-CZ" */ '@uikit/ui-kit/lib/locale/lang/cs-CZ.js');
    case 'da': // Danish (da)
      return async () => import(/* webpackChunkName: "ui-lc/da" */ '@uikit/ui-kit/lib/locale/lang/da.js');
    case 'de': // German (de)
      return async () => import(/* webpackChunkName: "ui-lc/de" */ '@uikit/ui-kit/lib/locale/lang/de.js');
    case 'ee': // Estonian (ee)
      return async () => import(/* webpackChunkName: "ui-lc/ee" */ '@uikit/ui-kit/lib/locale/lang/ee.js');
    case 'el': // Greek (el)
      return async () => import(/* webpackChunkName: "ui-lc/el" */ '@uikit/ui-kit/lib/locale/lang/el.js');
    case 'en': // English (en)
      return async () => import(/* webpackChunkName: "ui-lc/en" */ '@uikit/ui-kit/lib/locale/lang/en.js');
    case 'en-us':
      return async () => import(/* webpackChunkName: "ui-lc/en" */ '@uikit/ui-kit/lib/locale/lang/en.js');
    case 'es': // Spanish (es)
      return async () => import(/* webpackChunkName: "ui-lc/es" */ '@uikit/ui-kit/lib/locale/lang/es.js');
    // case 'eu': // Basque (eu)
    //   return async () => import(/* webpackChunkName: "ui-lc/eu" */ '@uikit/ui-kit/lib/locale/lang/eu.js');
    case 'fa': // Farsi (fa)
      return async () => import(/* webpackChunkName: "ui-lc/fa" */ '@uikit/ui-kit/lib/locale/lang/fa.js');
    case 'fi': // Finnish (fi)
      return async () => import(/* webpackChunkName: "ui-lc/fi" */ '@uikit/ui-kit/lib/locale/lang/fi.js');
    case 'fr': // French (fr)
      return async () => import(/* webpackChunkName: "ui-lc/fr" */ '@uikit/ui-kit/lib/locale/lang/fr.js');
    case 'he': // Hebrew (he)
      return async () => import(/* webpackChunkName: "ui-lc/he" */ '@uikit/ui-kit/lib/locale/lang/he.js');
    case 'hu': // Hungarian (hu)
      return async () => import(/* webpackChunkName: "ui-lc/hu" */ '@uikit/ui-kit/lib/locale/lang/hu.js');
    case 'id': // Indonesian (id)
      return async () => import(/* webpackChunkName: "ui-lc/id" */ '@uikit/ui-kit/lib/locale/lang/id.js');
    case 'it': // Italian (it)
      return async () => import(/* webpackChunkName: "ui-lc/it" */ '@uikit/ui-kit/lib/locale/lang/it.js');
    case 'ja': // Japanese (ja)
      return async () => import(/* webpackChunkName: "ui-lc/ja" */ '@uikit/ui-kit/lib/locale/lang/ja.js');
    // case 'km': // Khmer (km)
    //   return async () => import(/* webpackChunkName: "ui-lc/km" */ '@uikit/ui-kit/lib/locale/lang/km.js');
    case 'ko': // Korean (ko)
      return async () => import(/* webpackChunkName: "ui-lc/ko" */ '@uikit/ui-kit/lib/locale/lang/ko.js');
    // case 'ku': // Kurdish (ku)
    //   return async () => import(/* webpackChunkName: "ui-lc/ku" */ '@uikit/ui-kit/lib/locale/lang/ku.js');
    case 'kz': // Kazakh (kz)
      return async () => import(/* webpackChunkName: "ui-lc/kz" */ '@uikit/ui-kit/lib/locale/lang/kz.js');
    case 'lt': // Lithuanian (lt)
      return async () => import(/* webpackChunkName: "ui-lc/lt" */ '@uikit/ui-kit/lib/locale/lang/lt.js');
    case 'lv': // Latvian (lv)
      return async () => import(/* webpackChunkName: "ui-lc/lv" */ '@uikit/ui-kit/lib/locale/lang/lv.js');
    case 'mn': // Mongolian (mn)
      return async () => import(/* webpackChunkName: "ui-lc/mn" */ '@uikit/ui-kit/lib/locale/lang/mn.js');
    case 'nb':
      return async () => import(/* webpackChunkName: "ui-lc/nb-NO" */ '@uikit/ui-kit/lib/locale/lang/nb-NO.js');
    case 'nb-no': // Norwegian (nb-NO)
      return async () => import(/* webpackChunkName: "ui-lc/nb-NO" */ '@uikit/ui-kit/lib/locale/lang/nb-NO.js');
    case 'nl': // Dutch (nl)
      return async () => import(/* webpackChunkName: "ui-lc/nl" */ '@uikit/ui-kit/lib/locale/lang/nl.js');
    case 'pl': // Polish (pl)
      return async () => import(/* webpackChunkName: "ui-lc/pl" */ '@uikit/ui-kit/lib/locale/lang/pl.js');
    case 'pt': // Portuguese (pt)
      return async () => import(/* webpackChunkName: "ui-lc/pt" */ '@uikit/ui-kit/lib/locale/lang/pt.js');
    case 'pt-br': // Brazilian Portuguese (pt-br)
      return async () => import(/* webpackChunkName: "ui-lc/pt-br" */ '@uikit/ui-kit/lib/locale/lang/pt-br.js');
    // case 'ro': // Romanian (ro)
    //   return async () => import(/* webpackChunkName: "ui-lc/ro" */ '@uikit/ui-kit/lib/locale/lang/ro.js');
    case 'ru':
      return async () => import(/* webpackChunkName: "ui-lc/ru-RU" */ '@uikit/ui-kit/lib/locale/lang/ru-RU.js');
    case 'ru-ru': // Russian (ru-RU)
      return async () => import(/* webpackChunkName: "ui-lc/ru-RU" */ '@uikit/ui-kit/lib/locale/lang/ru-RU.js');
    case 'sk': // Slovak (sk)
      return async () => import(/* webpackChunkName: "ui-lc/sk" */ '@uikit/ui-kit/lib/locale/lang/sk.js');
    case 'sl': // Slovenian (sl)
      return async () => import(/* webpackChunkName: "ui-lc/sl" */ '@uikit/ui-kit/lib/locale/lang/sl.js');
    case 'sr': // Serbian (sr)
      return async () => import(/* webpackChunkName: "ui-lc/sr" */ '@uikit/ui-kit/lib/locale/lang/sr.js');
    case 'sv':
      return async () => import(/* webpackChunkName: "ui-lc/sv-SE" */ '@uikit/ui-kit/lib/locale/lang/sv-SE.js');
    case 'sv-se': // Swedish (sv-SE)
      return async () => import(/* webpackChunkName: "ui-lc/sv-SE" */ '@uikit/ui-kit/lib/locale/lang/sv-SE.js');
    case 'ta': // Tamil (ta)
      return async () => import(/* webpackChunkName: "ui-lc/ta" */ '@uikit/ui-kit/lib/locale/lang/ta.js');
    case 'th': // Thai (th)
      return async () => import(/* webpackChunkName: "ui-lc/th" */ '@uikit/ui-kit/lib/locale/lang/th.js');
    case 'tk': // Turkmen (tk)
      return async () => import(/* webpackChunkName: "ui-lc/tk" */ '@uikit/ui-kit/lib/locale/lang/tk.js');
    case 'tr':
      return async () => import(/* webpackChunkName: "ui-lc/tr-TR" */ '@uikit/ui-kit/lib/locale/lang/tr-TR.js');
    case 'tr-tr': // Turkish (tr-TR)
      return async () => import(/* webpackChunkName: "ui-lc/tr-TR" */ '@uikit/ui-kit/lib/locale/lang/tr-TR.js');
    case 'ua': // Ukrainian (ua)
      return async () => import(/* webpackChunkName: "ui-lc/ua" */ '@uikit/ui-kit/lib/locale/lang/ua.js');
    // case 'ug':
    //   return async () => import(/* webpackChunkName: "ui-lc/ug-CN" */ '@uikit/ui-kit/lib/locale/lang/ug-CN.js');
    // case 'ug-cn': // Uighur (ug-CN)
    //   return async () => import(/* webpackChunkName: "ui-lc/ug-CN" */ '@uikit/ui-kit/lib/locale/lang/ug-CN.js');
    case 'vi': // Vietnamese (vi)
      return async () => import(/* webpackChunkName: "ui-lc/vi" */ '@uikit/ui-kit/lib/locale/lang/vi.js');
    case 'zh':
      return async () => import(/* webpackChunkName: "ui-lc/zh-CN" */ '@uikit/ui-kit/lib/locale/lang/zh-CN.js');
    case 'zh-cn': // Simplified Chinese (zh-CN)
      return async () => import(/* webpackChunkName: "ui-lc/zh-CN" */ '@uikit/ui-kit/lib/locale/lang/zh-CN.js');
    case 'zh-tw': // Traditional Chinese (zh-TW)
      return async () => import(/* webpackChunkName: "ui-lc/zh-TW" */ '@uikit/ui-kit/lib/locale/lang/zh-TW.js');
    default:
      if (lang.split('-').length > 1) {
        return loadLocale(lang.split('-')[0]); // Find by language code
      }
      return loadLocale(DEFAULT_UI_LANG);
  }
}

const takeDefault = _ => _.default;

export default async function (lang) {
  const languageImporter = loadLocale(lang);
  await languageImporter()
    .then(takeDefault)
    .then(locale);
}
